module.exports = __webpack_public_path__ + "img/note.39c483fc.svg";